var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_promise-resolve.js
// module id = 347
// module chunks = 0